export default {
    themes: {
        title: 'How can we help you CHILL today?',
        bannerLive: {
            title: 'Join us',
            moreButton: 'More Upcoming Classes'
        },
        bannerMinutes: {
            title: 'Your daily Mindful Moment',
            moreButton: 'MORE MOMENTS'
        },
        themes: [
            {
                title: 'Intro to Meditation',
                theme: 'intro',
                disabled: false,
                muted: false,
                imageAlt: 'Waves',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/intro-meditation.jpg'
            },
            {
                title: 'Mini Meditations',
                theme: '10mins',
                duration: 659,
                disabled: false,
                muted: false,
                imageAlt: 'Sunset in mountains',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/10-mins-min.jpg'
            },
            {
                title: 'Stress + Anxiety',
                theme: 'stress',
                disabled: false,
                muted: false,
                imageAlt: 'Water',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/StressandAnxiety.jpg'
            },
            {
                title: 'Relationships',
                theme: 'relationships',
                disabled: false,
                muted: false,
                imageAlt: 'Birds over the sea',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/Relationships.jpg'
            },
            {
                title: 'Productivity',
                theme: 'productivity',
                disabled: false,
                muted: false,
                imageAlt: 'Snow peak',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/poductiviti3.jpg'
            },
            {
                title: 'Leadership',
                theme: 'leadership',
                disabled: false,
                muted: false,
                imageAlt: 'Bridge on the water',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/lederhip2.jpg'
            },
            {
                title: 'Focus',
                theme: 'focus',
                disabled: false,
                muted: false,
                imageAlt: 'Trees',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/focus.jpg'
            },
            {
                title: 'Creativity',
                theme: 'creativity',
                disabled: false,
                muted: false,
                imageAlt: 'Building',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/Creativity.jpg'
            },
            {
                title: 'Rest',
                theme: 'rest',
                disabled: false,
                muted: false,
                imageAlt: 'Night sky',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/rest.jpg'
            },
            {
                title: 'Yoga + Stretch',
                theme: 'yoga',
                disabled: false,
                muted: false,
                imageAlt: 'People practice yoga',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/yogameditation.jpg'
            },
            {
                title: 'Workshops',
                theme: 'workshops',
                disabled: false,
                muted: false,
                imageAlt: 'A woman playing a musical instrument',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/workshops.jpg'
            },
            {
                title: 'New Practices',
                theme: 'new',
                disabled: false,
                muted: true,
                imageAlt: 'Sunrise in the mountains',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/themes/new/New-final.jpg'
            }
        ]
    }
};
